import { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link} from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useAuth } from '../utils/AuthContext';
import { getOrders } from '../api/commerce';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import "../css/OrderHistory.css"



const OrderHistory = () => {
  const [orders, setOrders] = useState([]);
  const { user, isAuthenticated} = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    if (!isAuthenticated) {
      navigate(`/${lang}/login` , { state: { from: location }, replace: true });
    }
  }, [isAuthenticated, loading, navigate, location]);
  
  const fetchOrders = async () => {
    try {
      const res = await getOrders();
      setOrders(res.data.results);
      setLoading(false)
    } catch (error) {
      setError("Error loading user information:", error);
    } 
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  
  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) =>
    str.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  if (!user) return <p>You must be logged in to view order history.</p>;

  return (
    <div >
      {setlang === "en" ?
      <h2>Open Orders</h2>:
      <h2>سفارش‌های باز</h2>
      }
      {setlang === "en" ?
      <div className="orderHistory-list">
        {orders.length === 0 ? (
        <p>No orders yet.</p>
        ) : (
          orders.map((order) => (
            <div key={order.id}>
              {order.order_status!=="completed" && order.order_status!=="canceled" && (
                <div className='itemHist-list'>
                  <ul>
                    {order.items.map((item) => (
                      <li key={item.id}>
                        <p>{item.product_name}</p>
                        <p><strong>Price:</strong> IRT {new Number(item.price).toLocaleString()}</p>
                        <p>Arrives latest by: {dayjs.utc(item.arrival_date).calendar("jalali").locale("fa").format("YYYY/MM/DD")}</p>
                      </li>
                    ))}
                  </ul>
                  <p><strong>Total:</strong> IRT {new Number(order.total_amount).toLocaleString()}</p>
                  {order.order_status==="paid" ? (
                    <p>Order Status: will be shipped soon</p>
                  ):(
                    <p>Order Status: {order.order_status}</p>
                  )}
                  <p>Order Number: {order.order_number}</p>
                  <p><small>Order placed on: {dayjs.utc(order.created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD")}</small></p>
                </div>
              )}
            </div>
          ))
        )}
      </div> 
      :
      <div className="orderHistory-list">
        {orders.length === 0 ? (
        <p>شما در این لحظه سفارش باز ندارید</p>
        ) : (
          orders.map((order) => (
            <>
              {order.order_status!=="completed" && order.order_status!=="canceled" && (
                <div key={order.id} className='itemHist-list-fa'>
                  <ul>
                    {order.items.map((item) => (
                      <li key={item.id}>
                        <p>{item.product_name}</p>
                        <p>قیمت: {toPersiDigits(new Number(item.price).toLocaleString())} تومان</p>
                        <p>{toPersiDigits(dayjs.utc(item.arrival_date).calendar("jalali").locale("fa").format("YYYY/MM/DD"))} :دریافت تا تاریخ</p>
                      </li>
                    ))}
                  </ul>
                  <p><strong>جمع کل: </strong>{new Number(order.total_amount).toLocaleString()} تومان</p>
                  {order.order_status==="paid" ? (
                    <p><strong>وضعیت سفارش: </strong>به زودی ارسال خواهد شد </p>
                  ):(
                    <p>{order.order_status}</p>
                  )}
                  <p>{order.order_number} : شماره رهگیری</p>
                  <p><small>{toPersiDigits(dayjs.utc(order.created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD"))} :تاریخ سفارش</small></p>
                </div>
              )}
            </>
          ))
        )}
      </div>
      }
      
      <div className='info-sec-act'>
        <Link to={`/${lang}/review/open-orders`}>
        {setlang === "en" ?
          <button>View Orders</button>:
          <button>همه سفارش‌ها</button>
        }
        </Link>
      </div>
    </div>
  );
};

export default OrderHistory;
